import { render } from "./ServerConfiguration.vue?vue&type=template&id=6dd7cf96&lang=true"
import script from "./ServerConfiguration.vue?vue&type=script&lang=js"
export * from "./ServerConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__